export default function IconShipping({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0Shipping)">
        <path
          d="M22.9198 6.57L14.4598 2C14.4598 2 9.30368 4.7853 5.99984 6.57M22.9198 6.57L14.4598 11.14M22.9198 6.57V17.43L14.4598 22M5.99984 6.57C9.30368 8.3547 14.4598 11.14 14.4598 11.14M5.99984 6.57C5.99984 7.55155 5.99984 7.87525 5.99984 9V6.57ZM14.4598 11.14V22M14.4598 22L5.99984 17.43C5.99984 17.43 5.99984 17.0722 5.99984 15.5M0.5 11H8.23844M0.5 13.1076H6.50001"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0Shipping">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
